import React from "react";

import "./../../../assets/scss/style.scss";
import Aux from "../../../hoc/_Aux";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { compose } from "redux";
import axios from "axios";
import { APP_CONSTANTS } from "../../../App/utils/app_constants";
import cx from "classnames";
import { loginSucced, loginFailed } from "../../../store/_actions/auth";
import { saveRedireectUrl } from "../../../store/_actions/url";
import { initGA, logPageView } from "../../../App/utils/analytics";
import { setCookie } from "../../../App/utils/session";
class SignIn2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errors: [],
      username: "",
      password: "",
      submitted: false,
      apiError: ""
    };
  }

  // on inputs change event handler
  onChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  onFormSubmit = async event => {
    try {
      event.preventDefault();
      this.setState({ submitted: true, isLoading: true });
      if (this.isValidForm()) {
        const result = await axios.post(`${APP_CONSTANTS.API_URL}/login`, {
          username: this.state.username,
          password: this.state.password
        });

        if (result.data.status === 1) {
          this.setState({ isLoading: false });
          setCookie("jwt", result.data.token);
          this.props.onLoginSuccess(result.data.token);
          if (this.props.url.redirectTo !== "") {
            this.props.history.push(this.props.url.redirectTo);
          } else {
            this.props.history.push("/");
          }
        } else {
          this.setState({
            isLoading: false,
            apiError: "مشخصات ورود درست نمی‌باشد"
          });
        }
      } else {
        this.setState({
          isLoading: false,
          apiError: "فیلد های خالی را پر کنید"
        });
      }
    } catch (error) {
      if (error.response) {
        this.setState({
          isLoading: false,
          apiError: error.response.data.massege
        });
      } else {
        this.setState({ isLoading: false });
      }
    }
  };
  isValidForm = () => {
    const { username, password } = this.state;
    return username !== "" && password !== "";
  };

  render() {
    const { username, password, submitted } = this.state;
    return (
      <Aux>
        <div
          className="auth-wrapper aut-bg-img-side cotainer-fiuid align-items-stretch"
          dir="rtl"
        >
          <div className="row align-items-center w-100 align-items-stretch bg-white">
            <div className="col-lg-4 align-items-stret h-100 align-items-center d-flex justify-content-center">
              <div className=" auth-content text-center">
                <div className="mb-4">
                  <i className="feather icon-unlock auth-icon" />
                </div>
                <h3 className="mb-4">ورود</h3>
                <div className="form-group mb-3">
                  <label className="d-block text-right" htmlFor="email">
                    ایمیل
                  </label>
                  <input
                    type="email"
                    className={cx("form-control", {
                      "has-error": submitted && !username
                    })}
                    id="email"
                    placeholder="yourmail@gmail.com"
                    name="username"
                    onChange={this.onChange}
                  />
                  {submitted && !username && (
                    <div className="text-right text-danger my-2">
                      ایمیل خود را وارد کنید
                    </div>
                  )}
                </div>
                <div className="form-group mb-3">
                  <label className="d-block text-right" htmlFor="password">
                    رمز عبور
                  </label>
                  <input
                    type="password"
                    className={cx("form-control", {
                      "has-error": submitted && !username
                    })}
                    id="password"
                    placeholder="****"
                    name="password"
                    onChange={this.onChange}
                  />
                  {submitted && !password && (
                    <div className="text-right text-danger my-2">
                      رمز عبور خود را وارد کنید
                    </div>
                  )}
                </div>
                <Button
                  variant="dark"
                  block
                  className="shadow-2 mb-4 mx-0 text-center d-flex align-items-center justify-content-center"
                  onClick={this.onFormSubmit}
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <div
                      className="spinner-border spinner-border-sm mx-3"
                      role="status"
                    />
                  ) : null}
                  ورود
                </Button>{" "}
                <p
                  className="link mb-4 text-muted"
                  onClick={() => this.props.history.push("/register")}
                >
                  حساب کاربری ندارید؟ <strong>ثبت نام</strong>
                </p>
                <p
                  className="link mt-3 text-muted"
                  onClick={() => this.props.history.push("/reset-password")}
                >
                  رمز عبور خود را فراموش کرده‌اید؟{" "}
                  <strong>بازیابی رمز عبور</strong>
                </p>
                {/* {this.state.errors.length > 0 && (
                  <>
                    <strong className="text-right text-dark d-block mb-3">
                      خطا های زیر را بررسی کنید
                    </strong>
                    {this.state.errors.map(error => (
                      <div
                        className="alert alert-danger text-right fadein"
                        role="alert"
                      >
                        {error}
                      </div>
                    ))}
                  </>
                )} */}
                {this.state.apiError && (
                  <>
                    <strong className="text-right text-dark d-block mb-3">
                      خطا های زیر را بررسی کنید
                    </strong>
                    <div
                      className="alert alert-danger text-right fadein"
                      role="alert"
                    >
                      {this.state.apiError}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              className="d-none d-lg-flex col-lg-8 aut-bg-img align-items-center d-flex justify-content-center"
              style={{
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
                backgroundPosition: "center",
                background:
                  "linear-gradient(to right, #e32249, #e01171)" /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
              }}
            >
              <div className="col-md-8">
                <h1 className="text-white text-right mb-5">
                  تعهد ما به شما تولید محتوای با کیفیت است
                </h1>
                <p className="text-white text-right" dir="rtl">
                  از این نقطه به بعد ارتباط ما شکل جدیدی به خود خواهد گرفت و
                  تمام توان تیم فرامحتوا برای بهبود کسب و کار شما به کار گرفته
                  خواهد شد.
                </p>
              </div>
            </div>
          </div>
          <div className="snackbar">
            <strong>فیلد های مورد نیاز را پر کنید</strong>
          </div>
        </div>
      </Aux>
    );
  }
  async componentDidMount() {
    if (!window.GA_INITIALIZED) {
      initGA();
      window.GA_INITIALIZED = true;
    }
    logPageView();

    if (
      this.props.location.state &&
      this.props.location.state.from.pathname.startsWith("/new-order")
    ) {
      console.log(this.props.location.state.from.pathname);
      this.props.dispatchUrl(this.props.location.state.from.pathname);
    }
  }
}
const mapStateToProps = state => {
  return {
    rtlLayout: state.theme.rtlLayout,
    auth: state.auth,
    url: state.url
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onLoginSuccess: token => dispatch(loginSucced(token)),
    onLoginFailure: err => dispatch(loginFailed(err)),
    dispatchUrl: url => dispatch(saveRedireectUrl(url))
  };
};
const composedComponent = compose(
  connect(mapStateToProps, mapDispatchToProps)(SignIn2)
);

export default composedComponent;
